import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface IRoleResponse {
  message: string;
  payload: IRolePayload;
  page: IRolePage;
}

export interface IRolePayload {
  content: IRole[];
  page: IRolePage;
}

export interface IRolePage {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

export interface IRole {
  id: string;
  name: string;
  assignedUsersCount: number;
}

export interface IRoleCreatePayload {
  name: string;
  description: string;
  validFrom: string;
  validTo: string;
}

export interface IRoleByIdResponse {
  message: string;
  payload: IRoleByIdPayload;
}

export interface IRoleByIdPayload {
  id: string;
  name: string;
  description: string;
  validFrom: null;
  validTo: null;
  permissions: {
    id: string;
    name: string;
    description: string;
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private api: ApiService) {}

  getRoles(): Observable<IRole[]> {
    return this.api
      .GET<IRoleResponse>('roles')
      .pipe(map((response) => response.payload.content));
  }

  createRole(payload: IRoleCreatePayload): Observable<IRole> {
    return this.api.POST<IRole>('roles', payload);
  }

  getRoleById(id: string): Observable<IRoleByIdPayload> {
    return this.api
      .GET<IRoleByIdResponse>(`roles/${id}`)
      .pipe(map((response) => response.payload));
  }
}
